import { render, staticRenderFns } from "./InitialRecommendationBlock.vue?vue&type=template&id=78ed03d0&scoped=true&"
import script from "./InitialRecommendationBlock.vue?vue&type=script&lang=js&"
export * from "./InitialRecommendationBlock.vue?vue&type=script&lang=js&"
import style0 from "./InitialRecommendationBlock.vue?vue&type=style&index=0&id=78ed03d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ed03d0",
  null
  
)

export default component.exports